"use client";

import Link from "next/link";
import type { ComponentConfig } from "@puckeditor/core";

export type ConfirmationBlockProps = {
  heading?: string;
  message?: string;
  responseTime?: string;
  primaryText?: string;
  primaryLink?: string;
  secondaryText?: string;
  secondaryLink?: string;
};

export const ConfirmationBlock: ComponentConfig<ConfirmationBlockProps> = {
  label: "Inquiry Confirmation",
  fields: {
    heading: { type: "text", label: "Heading" },
    message: { type: "textarea", label: "Confirmation Message" },
    responseTime: { type: "text", label: "Response-Time Promise" },
    primaryText: { type: "text", label: "Primary Button Text" },
    primaryLink: { type: "text", label: "Primary Button Link" },
    secondaryText: { type: "text", label: "Secondary Button Text" },
    secondaryLink: { type: "text", label: "Secondary Button Link" },
  },
  defaultProps: {
    heading: "Inquiry Successfully Received",
    message: "Thank you for submitting your formulation requirements. Our cosmetic formulation and commercial teams will review the brief and contact you with the relevant next steps.",
    responseTime: "Your brief is queued for formulation-team review.",
    primaryText: "Return to Home Page",
    primaryLink: "/",
    secondaryText: "Explore Product Range",
    secondaryLink: "/product-range",
  },
  render: ({ heading, message, responseTime, primaryText, primaryLink, secondaryText, secondaryLink }) => (
    <section className="page-hero">
      <div className="container">
        <div className="mx-auto max-w-2xl rounded-2xl border border-[var(--border-subtle)] bg-[var(--bg-card)] px-6 py-10 text-center shadow-[var(--shadow-md)] sm:px-10">
          <div className="mx-auto mb-5 grid h-16 w-16 place-items-center rounded-2xl bg-[var(--brand-tint)] text-[var(--brand-primary-hover)]">
            <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <path d="m22 4-10 10.01-3-3" />
            </svg>
          </div>
          <h1 className="text-balance">{heading}</h1>
          <p className="lead mx-auto">{message}</p>
          {responseTime && <p className="mt-4 text-sm font-semibold text-[var(--slate-600)]">{responseTime}</p>}
          <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
            {primaryText && <Link className="btn btn-primary" href={primaryLink || "/"}>{primaryText}</Link>}
            {secondaryText && <Link className="btn btn-ghost" href={secondaryLink || "/product-range"}>{secondaryText}</Link>}
          </div>
        </div>
      </div>
    </section>
  ),
};
